import { formatBytes } from "@/lib/format";

export function Bytes({ value }: { value: number }) {
  return <span>{formatBytes(value)}</span>;
}
